<template>
  <div id="divSummary">
    <div style="color: black; font-size: 10.5pt; align: center">
      <fieldset class="EntryBlock">
        <div
          class="Flex_Table tblEntryForm"
          style="margin-left: 5px; margin-bottom: 3px"
        >
          <div class="Flex_Row">
            <div class="Flex_Cell_Inline" width="10%">
              <span>Booking Type : </span>
            </div>
            <div class="Flex_Cell_Inline" width="30%">
              <select
                id="ddlBookingType"
                v-model="BookingTypeIDMain"
                v-on:change="
                  Cancel();
                  GetBookingForTimeInterval(BookingTypeIDMain);
                "
              >
                <option
                  v-for="m in bookingTypeList"
                  :key="m.bookingTypeID"
                  v-bind:value="m.bookingTypeID"
                >
                  {{ m.bookingTypeName }}
                </option>
              </select>
            </div>
          </div>
          <div class="Flex_Row">
            <div class="Flex_Cell_Inline" width="10%">
              <span>From Date : </span>
            </div>
            <div class="Flex_Cell_Inline" width="35%">
              <span
                ><DateControl
                  style="width: 100%"
                  v-model="BookingFromDate"
                  v-on:change="GetBookingSlots()"
                ></DateControl
              ></span>
            </div>
            <div class="Flex_Cell_Inline" width="10%">
              <span>To Date : </span>
            </div>
            <div class="Flex_Cell_Inline" width="35%">
              <span
                ><DateControl
                  style="width: 100%"
                  v-model="BookingToDate"
                  v-on:change="GetBookingSlots()"
                ></DateControl
              ></span>
            </div>
          </div>
          <div class="Flex_Row">
            <div class="Flex_Cell_Inline" width="10%">
              <span>Days : </span>
            </div>
            <div class="Flex_Cell_Inline" width="12%">
              <span
                ><input
                  id="cbDays_1"
                  type="checkbox"
                  name="cbSunday"
                  value="1"
                  class="cbDays"
                  checked="checked"
                />
                <label for="cbDays_1" class="lblClass">Sunday</label></span
              >
            </div>
            <div class="Flex_Cell_Inline" width="12%">
              <span>
                <input
                  id="cbDays_2"
                  type="checkbox"
                  name="cbSunday"
                  value="2"
                  class="cbDays"
                  checked="checked"
                />
                <label for="rblGender_2" class="lblClass">Monday</label></span
              >
            </div>
            <div class="Flex_Cell_Inline" width="12%">
              <span
                ><input
                  id="cbDays_3"
                  type="checkbox"
                  name="cbTuesDay"
                  value="3"
                  class="cbDays"
                  checked="checked"
                />
                <label for="cbDays_3" class="lblClass">Tuesday</label></span
              >
            </div>
            <div class="Flex_Cell_Inline" width="13%">
              <span
                ><input
                  id="cbDays_4"
                  type="checkbox"
                  name="cbWednesday"
                  value="4"
                  class="cbDays"
                  checked="checked"
                />
                <label for="cbDays_4" class="lblClass">Wednesday</label></span
              >
            </div>
            <div class="Flex_Cell_Inline" width="12%">
              <span
                ><input
                  id="cbDays_5"
                  type="checkbox"
                  name="cbThrusday"
                  value="5"
                  class="cbDays"
                  checked="checked"
                />
                <label for="cbDays_5" class="lblClass">Thrusday</label></span
              >
            </div>
            <div class="Flex_Cell_Inline" width="12%">
              <span
                ><input
                  id="cbDays_6"
                  type="checkbox"
                  name="cbFriday"
                  value="6"
                  class="cbDays"
                  checked="checked"
                />
                <label for="cbDays_6" class="lblClass">Friday</label></span
              >
            </div>
            <div class="Flex_Cell_Inline" width="12%">
              <span
                ><input
                  id="cbDays_7"
                  type="checkbox"
                  name="cbSaturday"
                  value="7"
                  class="cbDays"
                  checked="checked"
                />
                <label for="cbDays_7" class="lblClass">Saturday</label></span
              >
            </div>
          </div>

          <fieldset>
            <legend>Slots</legend>
            <div class="Flex_Table">
              <div class="Flex_Row">
                <div
                  class="Flex_Table ekkGrid"
                  style="border-radius: 6px; font-size: 10pt"
                  align="center"
                >
                  <div class="Flex_Row GridHeader">
                    <div class="Flex_Cell" width="20%">From</div>
                    <div class="Flex_Cell" width="20%">To</div>
                    <div class="Flex_Cell" width="20%">
                      Online Bookings Available
                    </div>
                    <div class="Flex_Cell" width="20%">
                      Reserve Type Available
                    </div>
                    <div class="Flex_Cell" width="20%">Add New</div>
                  </div>
                  <div
                    class="Flex_Row GridContent"
                    v-for="(s, index) in slotList"
                    :key="index"
                  >
                    <div class="Flex_Cell" width="20%">
                      Hour &nbsp;Minute<br /><select
                        style="width: 50px"
                        id="ddlBookingSlotFromHH"
                        v-model="s.BookingSlotFromHH"
                        v-on:change="ChangeSlotTo(s, index)"
                      >
                        <option value="0">00</option>
                        <option value="1">01</option>
                        <option value="2">02</option>
                        <option value="3">03</option>
                        <option value="4">04</option>
                        <option value="5">05</option>
                        <option value="6">06</option>
                        <option value="7">07</option>
                        <option value="8">08</option>
                        <option value="9">09</option>
                        <option value="10">10</option>
                        <option value="11">11</option>
                        <option value="12">12</option>
                        <option value="13">13</option>
                        <option value="14">14</option>
                        <option value="15">15</option>
                        <option value="16">16</option>
                        <option value="17">17</option>
                        <option value="18">18</option>
                        <option value="19">19</option>
                        <option value="20">20</option>
                        <option value="21">21</option>
                        <option value="22">22</option>
                        <option value="23">23</option>
                      </select>
                      <select
                        style="width: 50px"
                        id="ddlBookingSlotFromMM"
                        v-model="s.BookingSlotFromMM"
                        v-on:change="ChangeSlotTo(s, index)"
                      >
                        <option value="0">00</option>
                        <option value="1">01</option>
                        <option value="2">02</option>
                        <option value="3">03</option>
                        <option value="4">04</option>
                        <option value="5">05</option>
                        <option value="6">06</option>
                        <option value="7">07</option>
                        <option value="8">08</option>
                        <option value="9">09</option>
                        <option value="10">10</option>
                        <option value="11">11</option>
                        <option value="12">12</option>
                        <option value="13">13</option>
                        <option value="14">14</option>
                        <option value="15">15</option>
                        <option value="16">16</option>
                        <option value="17">17</option>
                        <option value="18">18</option>
                        <option value="19">19</option>
                        <option value="20">20</option>
                        <option value="21">21</option>
                        <option value="22">22</option>
                        <option value="23">23</option>
                        <option value="24">24</option>
                        <option value="25">25</option>
                        <option value="26">26</option>
                        <option value="27">27</option>
                        <option value="28">28</option>
                        <option value="29">29</option>
                        <option value="30">30</option>
                        <option value="31">31</option>
                        <option value="32">32</option>
                        <option value="33">33</option>
                        <option value="34">34</option>
                        <option value="35">35</option>
                        <option value="36">36</option>
                        <option value="37">37</option>
                        <option value="38">38</option>
                        <option value="39">39</option>
                        <option value="40">40</option>
                        <option value="41">42</option>
                        <option value="42">42</option>
                        <option value="43">43</option>
                        <option value="44">44</option>
                        <option value="45">45</option>
                        <option value="46">46</option>
                        <option value="47">47</option>
                        <option value="48">48</option>
                        <option value="49">49</option>
                        <option value="50">50</option>
                        <option value="51">51</option>
                        <option value="52">52</option>
                        <option value="53">53</option>
                        <option value="54">54</option>
                        <option value="55">55</option>
                        <option value="56">56</option>
                        <option value="57">57</option>
                        <option value="58">58</option>
                        <option value="59">59</option>
                      </select>
                    </div>
                    <div class="Flex_Cell" width="20%">
                      Hour &nbsp;Minute<br /><select
                        style="width: 50px"
                        id="ddlBookingSlotToHH"
                        v-model="s.BookingSlotToHH"
                      >
                        <option value="0">00</option>
                        <option value="1">01</option>
                        <option value="2">02</option>
                        <option value="3">03</option>
                        <option value="4">04</option>
                        <option value="5">05</option>
                        <option value="6">06</option>
                        <option value="7">07</option>
                        <option value="8">08</option>
                        <option value="9">09</option>
                        <option value="10">10</option>
                        <option value="11">11</option>
                        <option value="12">12</option>
                        <option value="13">13</option>
                        <option value="14">14</option>
                        <option value="15">15</option>
                        <option value="16">16</option>
                        <option value="17">17</option>
                        <option value="18">18</option>
                        <option value="19">19</option>
                        <option value="20">20</option>
                        <option value="21">21</option>
                        <option value="22">22</option>
                        <option value="23">23</option>
                      </select>
                      <select
                        style="width: 50px"
                        id="ddlBookingSlotToMM"
                        v-model="s.BookingSlotToMM"
                      >
                        <option value="0">00</option>
                        <option value="1">01</option>
                        <option value="2">02</option>
                        <option value="3">03</option>
                        <option value="4">04</option>
                        <option value="5">05</option>
                        <option value="6">06</option>
                        <option value="7">07</option>
                        <option value="8">08</option>
                        <option value="9">09</option>
                        <option value="10">10</option>
                        <option value="11">11</option>
                        <option value="12">12</option>
                        <option value="13">13</option>
                        <option value="14">14</option>
                        <option value="15">15</option>
                        <option value="16">16</option>
                        <option value="17">17</option>
                        <option value="18">18</option>
                        <option value="19">19</option>
                        <option value="20">20</option>
                        <option value="21">21</option>
                        <option value="22">22</option>
                        <option value="23">23</option>
                        <option value="24">24</option>
                        <option value="25">25</option>
                        <option value="26">26</option>
                        <option value="27">27</option>
                        <option value="28">28</option>
                        <option value="29">29</option>
                        <option value="30">30</option>
                        <option value="31">31</option>
                        <option value="32">32</option>
                        <option value="33">33</option>
                        <option value="34">34</option>
                        <option value="35">35</option>
                        <option value="36">36</option>
                        <option value="37">37</option>
                        <option value="38">38</option>
                        <option value="39">39</option>
                        <option value="40">40</option>
                        <option value="41">42</option>
                        <option value="42">42</option>
                        <option value="43">43</option>
                        <option value="44">44</option>
                        <option value="45">45</option>
                        <option value="46">46</option>
                        <option value="47">47</option>
                        <option value="48">48</option>
                        <option value="49">49</option>
                        <option value="50">50</option>
                        <option value="51">51</option>
                        <option value="52">52</option>
                        <option value="53">53</option>
                        <option value="54">54</option>
                        <option value="55">55</option>
                        <option value="56">56</option>
                        <option value="57">57</option>
                        <option value="58">58</option>
                        <option value="59">59</option>
                      </select>
                    </div>
                    <div class="Flex_Cell" width="20%">
                      <br />
                      <input
                        type="text"
                        v-model="s.noOfOnlineBookingsAvailable"
                        regExp="([0-9])*"
                        maxlength="4"
                        style="display: inline-block; width: 50px"
                      />
                    </div>
                    <div class="Flex_Cell" width="20%" style="display: none">
                      <br />
                      <input
                        type="text"
                        v-model="s.noOfOfflineBookingsAvailable"
                        regExp="([0-9])*"
                        maxlength="4"
                        style="display: inline-block; width: 50px"
                      />
                    </div>
                    <div class="Flex_Cell" width="20%">
                      <br />
                      <input
                        type="text"
                        v-model="s.noOfReserve1Available"
                        regExp="([0-9])*"
                        maxlength="4"
                        style="display: inline-block; width: 50px"
                      />
                    </div>
                    <div class="Flex_Cell" width="20%" style="display: none">
                      <br />
                      <input
                        type="text"
                        v-model="s.noOfReserve2Available"
                        regExp="([0-9])*"
                        maxlength="4"
                        style="display: inline-block; width: 50px"
                      />
                    </div>
                    <div class="Flex_Cell" width="20%">
                      <br />
                      <span
                        v-if="
                          index + 1 == slotList.length && slotList.length > 1
                        "
                        class="glyphicons Red bin"
                        v-on:click="DeleteSlot(s, index)"
                        style="cursor: pointer"
                        title="Delete this row"
                      ></span>
                      <span
                        v-if="index + 1 == slotList.length"
                        class="glyphicons circle_plus"
                        v-on:click="AddNewSlot()"
                        style="cursor: pointer"
                        title="Add New"
                      ></span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div
              style="border-bottom: solid 1px darkgrey"
              class="Flex_Row"
              v-for="(s, index) in slotList"
              :key="index"
            >
              <div
                class="Flex_Cell"
                valign="middle"
                style="width: 20%"
                align="center"
              >
                <!-- <input
                  type="time"
                  v-model="s.bookingSlotFrom"
                  style="display:inline-block"
                /> -->
              <!-- {{ s.BookingSlotFrom }} -->

              <!-- <Time
                  style="width: 70px;display:none"
                  v-model="s.BookingSlotFrom"
                ></Time> -->
              <!-- <input type="datetime-local" value="01/Jan/1900" /> 
              </div>
              <div
                class="Flex_Cell"
                valign="middle"
                style="width: 20%"
                align="center"
              >-->
              <!-- <input
                  type="time"
                  v-model="s.bookingSlotTo"
                  style="display:inline-block"
                /> -->

              <!-- <Time
                  style="width: 70px;display:none"
                  v-model="s.BookingSlotTo"
                ></Time>
              </div>
              <div
                class="Flex_Cell"
                valign="middle"
                style="width: 15%"
                align="center"
              ></div>
              <div
                class="Flex_Cell"
                valign="middle"
                style="width: 15%; display: none"
                regExp="([0-9])*"
                maxlength="4"
                align="center"
              ></div>
              <div
                class="Flex_Cell"
                style="width: 15%"
                valign="middle"
                align="center"
              ></div>
              <div
                class="Flex_Cell"
                style="width: 15%; display: none"
                valign="middle"
                align="center"
              ></div>

              <div
                class="Flex_Cell"
                style="width: 10%"
                valign="middle"
                align="center"
              ></div>
            </div>  -->
            </div>
          </fieldset>

          <div class="Flex_Row"><div class="Flex_Cell_Inline"></div></div>
          <!-- <div class="Flex_Row" v-if="BookingSlotID != -1">
          <div class="Flex_Cell_Inline" width="20%">
            <input
              id="cbIsActive"
              type="checkbox"
              name="cbIsActive"
              model="IsActive"
            />
            <span>Active</span>
          </div>
          <div class="Flex_Cell_Inline" width="5%"><span>Comment</span></div>
          <div class="Flex_Cell_Inline" width="75%">
            <input type="text" v-model="Comments" width="500px" />
          </div>
        </div> -->
          <div class="Flex_Row"><div class="Flex_Cell_Inline"></div></div>
          <div class="Flex_Row">
            <div class="Flex_Cell_Inline" width="25%">
              <input
                type="button"
                value="Generate"
                v-on:click="GenerateSlot(1)"
                style="display: inline-block; width: 100px"
              />
            </div>
            <div class="Flex_Cell_Inline" width="25%">
              <input
                type="button"
                value="Finalize"
                v-on:click="GenerateSlot(5)"
                style="display: inline-block; width: 100px"
              />
            </div>
            <!-- <div class="Flex_Cell_Inline" width="25%">
            <input
              type="button"
              value="Save Slot"
              v-on:click="GenerateSlot(2)"
              style="display:inline-block;width:100px"
            />
          </div> -->
            <div class="Flex_Cell_Inline" width="25%">
              <input
                type="button"
                value="Cancel"
                v-on:click="Cancel()"
                style="display: inline-block; width: 100px"
              />
            </div>
          </div>
          <div class="Flex_Row">
            <div class="Flex_Cell">
              <div
                class="Flex_Table ekkGrid"
                v-if="bookingSlot_List.length > 0"
              >
                <div
                  class="Flex_Row GridHeader"
                  valign="middle"
                  style="min-height: 35px"
                >
                  <div
                    class="Flex_Cell"
                    align="center"
                    valign="middle"
                    style="width: 2.9%"
                  >
                    <input
                      type="checkbox"
                      v-on:click="SelectAll()"
                      style="padding: 5px; width: 100%"
                      title="Click to select all."
                      v-model="IsAllSelect"
                    />
                  </div>
                  <div
                    class="Flex_Cell"
                    align="center"
                    valign="middle"
                    style="width: 12.9%"
                  >
                    Slot Date
                  </div>
                  <div
                    class="Flex_Cell"
                    align="center"
                    valign="middle"
                    style="width: 12.9%"
                  >
                    Slot Details
                  </div>
                  <div
                    class="Flex_Cell"
                    align="center"
                    valign="middle"
                    style="width: 6.9%"
                  >
                    Online Bookings Available
                  </div>
                  <div
                    class="Flex_Cell"
                    align="center"
                    valign="middle"
                    style="width: 6.9%"
                  >
                    Online Booking Left
                  </div>
                  <div
                    class="Flex_Cell"
                    align="center"
                    valign="middle"
                    style="width: 6.9%; display: none"
                  >
                    Offline Bookings Available
                  </div>
                  <div
                    class="Flex_Cell"
                    align="center"
                    valign="middle"
                    style="width: 6.9%; display: none"
                  >
                    Offline Bookings Left
                  </div>
                  <div
                    class="Flex_Cell"
                    align="center"
                    valign="middle"
                    style="width: 6.9%"
                  >
                    Reserve Seats Available
                  </div>
                  <div
                    class="Flex_Cell"
                    align="center"
                    valign="middle"
                    style="width: 6.9%; display: none"
                  >
                    Reserve Seats Left
                  </div>

                  <div
                    class="Flex_Cell"
                    align="center"
                    valign="middle"
                    style="width: 6.9%; display: none"
                  >
                    Reserve2 Available
                  </div>

                  <div
                    class="Flex_Cell"
                    align="center"
                    valign="middle"
                    style="width: 6.9%; display: none"
                  >
                    Reserve2 Left
                  </div>

                  <div
                    class="Flex_Cell"
                    align="center"
                    valign="middle"
                    style="width: 6.9%"
                  >
                    Active
                  </div>

                  <div
                    class="Flex_Cell"
                    align="center"
                    valign="middle"
                    style="width: 32.9%"
                  >
                    Comments
                  </div>

                  <div
                    class="Flex_Cell"
                    align="center"
                    valign="middle"
                    style="width: 10.9%"
                  >
                    <input
                      type="button"
                      v-on:click="EditSlotFinal(-1)"
                      value="Edit"
                      style="padding: 5px; width: 100%"
                      title="Click to edit all selected."
                    />
                    <input
                      type="button"
                      v-on:click="DeleteSlotMultiple()"
                      value="Delete"
                      style="padding: 5px; width: 100%"
                      title="Click to delete all selected. "
                    />
                  </div>
                </div>
                <div class="GridContent" style="height: calc(59vh - 100px)">
                  <div
                    class="Flex_Row"
                    style="min-height: 35px"
                    v-for="bsl in bookingSlot_List"
                    :key="bsl[0]"
                  >
                    <div
                      class="Flex_Cell"
                      align="center"
                      valign="middle"
                      style="width: 3%"
                    >
                      <input
                        type="checkbox"
                        style="padding: 5px; width: 100%"
                        title="Click to select."
                        v-model="bsl[16]"
                        :value="bsl[0]"
                        v-on:click="SelectBookingSlotID($event.target, bsl[0])"
                        v-if="bsl[15] == 1"
                      />
                    </div>
                    <div
                      class="Flex_Cell"
                      align="center"
                      valign="middle"
                      style="width: 13%"
                    >
                      <span>{{ bsl[1] }}</span>
                    </div>

                    <div
                      class="Flex_Cell"
                      align="center"
                      valign="middle"
                      style="width: 13%"
                    >
                      <span>{{ bsl[4] }}</span>
                    </div>
                    <div
                      class="Flex_Cell"
                      align="center"
                      valign="middle"
                      style="width: 7%"
                    >
                      <span>{{ bsl[5] }}</span>
                    </div>
                    <div
                      class="Flex_Cell"
                      align="center"
                      valign="middle"
                      style="width: 7%"
                    >
                      <span>{{ bsl[6] }}</span>
                    </div>
                    <div
                      class="Flex_Cell"
                      align="center"
                      valign="middle"
                      style="width: 7%; display: none"
                    >
                      <span>{{ bsl[7] }}</span>
                    </div>
                    <div
                      class="Flex_Cell"
                      align="center"
                      valign="middle"
                      style="width: 7%; display: none"
                    >
                      <span>{{ bsl[8] }}</span>
                    </div>
                    <div
                      class="Flex_Cell"
                      align="center"
                      valign="middle"
                      style="width: 7%"
                    >
                      <span>{{ bsl[9] }}</span>
                    </div>

                    <div
                      class="Flex_Cell"
                      align="center"
                      valign="middle"
                      style="width: 7%; display: none"
                    >
                      <span>{{ bsl[10] }}</span>
                    </div>

                    <div
                      class="Flex_Cell"
                      align="center"
                      valign="middle"
                      style="width: 7%; display: none"
                    >
                      <span>{{ bsl[11] }}</span>
                    </div>

                    <div
                      class="Flex_Cell"
                      align="center"
                      valign="middle"
                      style="width: 7%; display: none"
                    >
                      <span>{{ bsl[12] }}</span>
                    </div>

                    <div
                      class="Flex_Cell"
                      align="center"
                      valign="middle"
                      style="width: 7%"
                    >
                      <span v-if="bsl[13] == 1" style="color: green">Yes</span>
                      <span v-if="bsl[13] == 0" style="color: red">No</span>
                      <span v-if="bsl[13] == -111" style="color: orange"
                        >Pending</span
                      >
                    </div>
                    <div
                      class="Flex_Cell"
                      style="width: 43%"
                      align="center"
                      valign="middle"
                    >
                      <span>{{ bsl[14] }}</span>
                    </div>
                    <!--<div
                    class="Flex_Cell"
                    align="center"
                    valign="middle"
                    v-if="bsl[15] == 1"
                    width="0%"
                  >
                     <input
                      type="button"
                      v-on:click="EditSlot(bsl)"
                      value="Edit"
                      style="padding: 5px;width:100%"
                      title="Click to Edit"
                    />
                    <input
                      type="button"
                      v-on:click="DeleteSlotFinal(bsl[0])"
                      value="Delete"
                      style="padding: 5px;width:100%"
                      title="Click to Delete"
                    /> 
                  </div>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
    </div>

    <ModalPopup
      title="Edit Selected Slot"
      ref="ModalPopup1"
      @closed="modalPopupClosed"
      @opened="modalPopupShown"
      v-model="specificEditDiv"
      :okButton="$refs.btnOk"
      :cancelButton="$refs.btnOk"
    >
      <input type="hidden" v-model="hdnBookingSlotID" id="hdnBookingSlotID" />

      <div class="Flex_Table" style="width: 500px">
        <div class="Flex_Row">
          <div class="Flex_Cell">
            <fieldset>
              <div class="Flex_Table" style="width: 450px">
                <div class="Flex_Row">
                  <div class="Flex_Cell" style="width: 40%">
                    Online Bookings Available
                  </div>
                  <div class="Flex_Cell" style="width: 40%">
                    Reserve1 Available
                  </div>
                  <div class="Flex_Cell" style="width: 20%">Active</div>
                </div>
                <div class="Flex_Row">
                  <div class="Flex_Cell" style="width: 40%">
                    <input
                      type="text"
                      v-model="NoOfOnlineBookingsAvailablePopUp"
                      regExp="([0-9])*"
                      maxlength="4"
                      style="display: inline-block; width: 50px"
                    />
                  </div>
                  <div class="Flex_Cell" style="width: 40%">
                    <input
                      type="text"
                      v-model="NoOfReserve1AvailablePopUp"
                      regExp="([0-9])*"
                      maxlength="4"
                      style="display: inline-block; width: 50px"
                    />
                  </div>
                  <div class="Flex_Cell" style="width: 20%">
                    <!-- <input
                      type="checkbox"
                      v-model="IsActivePopUp"                      
                      style="display:inline-block"
                    /> -->
                    <input
                      type="checkbox"
                      style="padding: 5px; width: 100%"
                      title="Click to active."
                      v-model="IsActivePopUp"
                      id="cbIsActive"
                    />
                  </div>
                </div>
                <div class="Flex_Row">
                  <div class="Flex_Cell" style="width: 100%" align="left">
                    Comment:
                  </div>
                </div>
                <div class="Flex_Row">
                  <div class="Flex_Cell" style="width: 100%" align="center">
                    <textarea
                      id="txtEditComment"
                      v-model="Comments"
                      style="width: 450px"
                    />
                  </div>
                </div>
                <div class="Flex_Row">
                  <div class="Flex_Cell" style="width: 100%" align="center">
                    <input
                      type="button"
                      id="btnSave"
                      value="Save"
                      v-on:click="EditBookingSlotFinal()"
                      style="width: 100px"
                    />
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </ModalPopup>
  </div>
</template>
<script>
import vue from "vue";
import Router from "vue-router";
import AcceptInput from "./ekkControls/AcceptInput";
import DateControl from "./ekkControls/DateControl";
import Time from "./ekkControls/Time";
import ModalPopup from "./ekkControls/ModalPopup";
import MasterJS from "./servicesJS/Master";
import BookingSlotsJS from "./servicesJS/BookingSlots";
export default {
  name: "StatusSummary",
  components: {
    AcceptInput: AcceptInput,
    DateControl: DateControl,
    Time: Time,
    ModalPopup: ModalPopup,
  },
  data() {
    return {
      bookingTypeList: [],
      bookingTypeID: -1,
      slotList: [],
      slotListItem: {
        BookingSlotFrom: new Date(),
        BookingSlotTo: new Date(),
        noOfBookingsAvailable: 0,
        noOfforeignerBookingsAvailable: 0,
        vIPQuotaAvailable: 0,
        extraQuotaAvailable: 0,
      },
      SetupData: [],
      BookingFromDate: "1900-1-1",
      BookingToDate: "1900-1-1",
      BookingTypeIDMain: -1,
      BookingSlotID: -1,
      strBookingDays: "",
      bookingSlot_List: [],
      IsActive: 0,
      curTime: new Date(),
      bookingForValue: 0,
      IsForGroup: "",
      IsAllSelect: 0,
      NoOfReserve1AvailablePopUp: 0,
      NoOfOnlineBookingsAvailablePopUp: 0,
      specificEditDiv: false,
      IsActivePopUp: false,
      Comments: "",
      hdnBookingSlotID: [],
      bookingForUnitsName: "",
    };
  },
  methods: {
    getbookingTypeList() {
      const _data_ = {
        isActive: 1,
        type: 1,
      };
      MasterJS.getBookingTypes(_data_).then(
        (response) => {
          this.bookingTypeList = response.data;
          this.BookingTypeIDMain = response.data[0].bookingTypeID;
          this.GetBookingForTimeInterval(this.BookingTypeIDMain);
          this.GetBasicSlotData();
        },
        (error) => {}
      );
    },
    GetSetupData() {
      const _data_ = {};
      MasterJS.getSetupData(_data_).then(
        (response) => {
          this.SetupData = response.data;
          this.getbookingTypeList();
          var dayArray = this.SetupData[0][12].split(",");

          for (var j = 0; j <= dayArray.length; j++) {
            for (var i = 1; i < 8; i++) {
              if (i == dayArray[j]) {
                var cbDays = document.getElementById("cbDays_" + i);
                cbDays.checked = false;
                cbDays.disabled = true;
              } else {
                //var cbDays = document.getElementById("cbDays_" + i);
              }
            }
          }
        },
        (error) => {}
      );
    },
    GetBasicSlotData() {
      this.slotList.push({
        BookingSlotFromHH: "0", //new Date(),
        BookingSlotFromMM: "0", //new Date(),
        BookingSlotToHH: "0", //new Date(),
        BookingSlotToMM: "0", //new Date(),
        noOfOnlineBookingsAvailable: 0,
        noOfOfflineBookingsAvailable: 0,
        noOfReserve1Available: 0,
        noOfReserve2Available: 0,
      });
    },
    AddNewSlot() {
      this.slotList.push({
        BookingSlotFromHH: "0", //new Date(),
        BookingSlotFromMM: "0", //new Date(),
        BookingSlotToHH: "0", //new Date(),
        BookingSlotToMM: "0", //new Date(),
        noOfOnlineBookingsAvailable: 0, // this.noOfBookingsAvailable,
        noOfOfflineBookingsAvailable: 0, // this.noOfforeignerBookingsAvailable,
        noOfReserve1Available: 0, //this.vIPQuotaAvailable,
        noOfReserve2Available: 0, //this.extraQuotaAvailable
      });
    },
    DeleteSlot(rowData, index) {
      if (confirm("Are you sure ?")) {
        this.slotList.splice(index, 1);
      }
    },
    GenerateSlot(type) {
      if (type == 1) {
        if (this.BookingFromDate <= new Date()) {
          alert("Select Proper From Date.");
          return;
        }
        // alert(
        //   "this.BookingFromDate : " +
        //     this.BookingFromDate +
        //     " " +
        //     "this.BookingToDate : " +
        //     this.BookingToDate
        // );
        // if (this.BookingFromDate > this.BookingToDate) {
        //   alert("Select Proper To date.");
        //   return;
        // }
        this.strBookingDays = "";
        for (var i = 1; i < 8; i++) {
          var cbDays = document.getElementById("cbDays_" + i);
          if (cbDays.checked == true) {
            if (this.strBookingDays == "") {
              this.strBookingDays = cbDays.value;
            } else {
              this.strBookingDays = this.strBookingDays + "," + cbDays.value;
            }
          }
        }

        if (this.strBookingDays == "") {
          alert("Select days.");
          return;
        }
      }

      var formData = new FormData();
      formData.append(
        "BasicData",
        JSON.stringify(this.formDataMaking(type, 0))
      );
      BookingSlotsJS.SetBookingSlots(formData).then(
        (response) => {
          if (response.data.isSuccess) {
            vue.nextTick(() => {
              this.BookingSlotID = -1;
              this.slotList = [];
              this.GetBasicSlotData();
              this.GetBookingSlots();
              this.strBookingDays = "";
            });
            MessageBox.show({
              message: response.data.msg,
              type: "success",
              title: "Success",
            });
          } else {
            MessageBox.show({
              message: response.data.msg,
              type: "error",
              title: "Error",
            });
          }
        },
        (error) => {}
      );
    },

    formDataMaking(type, isVerify) {
      var slotTable = [];
      if (type == 1 || type == 2) {
        this.slotList.forEach((element) => {
          if (1 == 1) {
            slotTable.push({
              BookingSlotFromHH: element.BookingSlotFromHH,
              BookingSlotFromMM: element.BookingSlotFromMM,
              BookingSlotToHH: element.BookingSlotToHH,
              BookingSlotToMM: element.BookingSlotToMM,
              NoOfOnlineBookingsAvailable:
                element.noOfOnlineBookingsAvailable == ""
                  ? "0"
                  : element.noOfOnlineBookingsAvailable,
              NoOfOfflineBookingsAvailable:
                element.noOfOfflineBookingsAvailable == ""
                  ? "0"
                  : element.noOfOfflineBookingsAvailable,
              NoOfReserve1Available:
                element.noOfReserve1Available == ""
                  ? "0"
                  : element.noOfReserve1Available,
              NoOfReserve2Available:
                element.noOfReserve2Available == ""
                  ? "0"
                  : element.noOfReserve2Available,
            });
          } else {
            alert("Enter Slot Properly.");
            return;
          }
        });
      }
      var isActiveTemp = 0;
      if (type == 2) {
        var cbIsActive = document.getElementById("cbIsActive");
        if (cbIsActive.checked) {
          isActiveTemp = 1;
        }
      }
      var basicData = {
        BookingSlotID: this.BookingSlotID,
        BookingTypeID: this.BookingTypeIDMain,
        BookingDays: this.strBookingDays,
        BookingFromDate: this.BookingFromDate,
        BookingToDate: this.BookingToDate,
        IsActive: isActiveTemp,
        Comments: this.Comments,
        Type: type,
        TableSlotData: slotTable,
      };

      return basicData;
    },

    GetBookingSlots() {
      this.bookingSlot_List = [];
      const _data_ = {
        BookingSlotID: this.BookingSlotID,
        BookingTypeID: this.BookingTypeIDMain,
        BookingFromDate: this.BookingFromDate,
        BookingToDate: this.BookingToDate,
        Type: 1,
      };
      BookingSlotsJS.GetBookingSlots(_data_).then(
        (response) => {
          if (response.data.length > 0) {
            if (response.data) this.bookingSlot_List = response.data;
            //console.log(this.bookingSlot_List);
            this.bookingSlot_List.forEach((element) => {
              if (element[16] == "1") {
                element[16] = 1;
              } else {
                element[16] = 0;
              }
            });
          }
        },
        (error) => {}
      );
    },
    DeleteSlotFinal(BookingSlotID) {
      if (confirm("Are you sure ?")) {
        this.BookingSlotID = -1;
        this.BookingSlotID = BookingSlotID;
        this.GenerateSlot(3);
        this.BookingSlotID = -1;
        this.GetBookingSlots();
      }
    },
    EditSlot(bsl) {
      this.BookingSlotID = bsl[0];
      const _data_ = {
        BookingSlotID: bsl[0],
        BookingTypeID: this.BookingTypeIDMain,
        BookingFromDate: bsl[1],
        BookingToDate: bsl[1],
        Type: 1,
      };
      BookingSlotsJS.GetBookingSlots(_data_).then(
        (response) => {
          var cbIsActive = document.getElementById("cbIsActive");
          if (response.data[0][13] == 1) {
            cbIsActive.checked = true;
          } else {
            cbIsActive.checked = false;
          }

          this.Comments = response.data[0][14];
          this.bookingSlot_ListTemp = response.data;

          this.slotList = [];
          this.slotList.push({
            BookingSlotFromHH: "0", // response.data[0][2],
            BookingSlotFromMM: "0", // response.data[0][2],
            BookingSlotToHH: "0", //response.data[0][3],
            BookingSlotToMM: "0", //response.data[0][3],
            noOfBookingsAvailable: response.data[0][5],
            noOfforeignerBookingsAvailable: response.data[0][7],
            vIPQuotaAvailable: response.data[0][9],
            extraQuotaAvailable: response.data[0][11],
          });
        },
        (error) => {}
      );
    },
    Cancel() {
      this.strBookingDays = -1;
      this.BookingFromDate = "1900-1-1";
      this.BookingToDate = "1900-1-1";
      this.slotList = [];
      this.GetBasicSlotData();
      this.bookingSlot_List = [];
      this.strBookingDays = "";
      this.BookingSlotID = -1;
      this.IsAllSelect = 0;
    },

    GetBookingForTimeInterval(BookingTypeID) {
      let lstBookingForTimeInterval = [];

      lstBookingForTimeInterval = this.bookingTypeList.filter((item) => {
        return item.bookingTypeID == BookingTypeID;
      });

      this.bookingForValue = lstBookingForTimeInterval[0].bookingForValue;
      this.bookingForUnitsName =
        lstBookingForTimeInterval[0].bookingForUnitsName;
      this.isForGroup = lstBookingForTimeInterval[0].isForGroup;
      // console.log(
      //   "this.bookingForValue : " +
      //     this.bookingForValue +
      //     " this.bookingForUnitsName :" +
      //     this.bookingForUnitsName
      // );
      // console.log(lstBookingForTimeInterval);
    },
    ChangeSlotTo(rowData, index) {
      // if (this.isForGroup == "0") {
      if (this.bookingForUnitsName == "Minutes") {
        let a = parseInt(this.slotList[index].BookingSlotFromHH);
        let b = parseInt(this.slotList[index].BookingSlotFromMM);
        let c = parseInt(this.bookingForValue);
        var hh = c / 60;
        hh = hh + a;
        var rhh = Math.floor(hh);
        var mm = (hh - rhh) * 60;
        mm = mm + b;
        if (mm > 59) {
          var rrhh = rhh + mm / 60;
          rhh = Math.floor(rrhh);
          mm = (rrhh - rhh) * 60;
        }
        var rmin = Math.round(mm);
        this.slotList[index].BookingSlotToHH = rhh;
        this.slotList[index].BookingSlotToMM = rmin;
      } else {
        let x = parseInt(this.slotList[index].BookingSlotFromHH);
        let y = parseInt(this.bookingForValue);
        let z = x + y;
        if (z > 23) {
          z = z - 24;
        }
        this.slotList[index].BookingSlotToHH = z;
        let a = parseInt(this.slotList[index].BookingSlotFromMM);

        this.slotList[index].BookingSlotToMM = a;
      }
      // }
    },
    SelectAll() {
      if (this.IsAllSelect == 0) {
        this.bookingSlot_List.forEach((r) => {
          r[16] = 1;
        });
      } else {
        this.bookingSlot_List.forEach((r) => {
          r[16] = 0;
        });
      }
    },
    modalPopupClosed(e) {},
    modalPopupShown(e) {},
    openEditPopup(BookingSlotID) {
      this.hdnBookingSlotID = BookingSlotID;
      this.specificEditDiv = true;
    },
    closeEditPopup() {
      this.hdnBookingSlotID = [];
      this.specificEditDiv = false;
      this.NoOfOnlineBookingsAvailablePopUp = 0;
      this.NoOfReserve1AvailablePopUp = 0;
      this.IsActivePopUp = false;
      this.Comments = "";
    },
    EditSlotFinal() {
      var SelectedBookingSlotID = [];
      this.bookingSlot_List.forEach((element) => {
        if (element[16] == 1) SelectedBookingSlotID.push(element[0]);
      });
      this.openEditPopup(SelectedBookingSlotID);
    },
    SelectBookingSlotID(obj, BookingSlotID) {
      this.bookingSlot_List.forEach((element) => {
        if (element[0] == BookingSlotID) {
          if (obj.checked == true) {
            element[16] = 1;
          } else {
            element[16] = 0;
          }
        }
      });
    },

    EditBookingSlotFinal() {
      this.BookingSlotID = -1;
      this.slotList = [];
      this.slotList.push({
        BookingSlotFromHH: "0",
        BookingSlotFromMM: "0",
        BookingSlotToHH: "0",
        BookingSlotToMM: "0",
        noOfOnlineBookingsAvailable: this.NoOfOnlineBookingsAvailablePopUp,
        noOfOfflineBookingsAvailable: 0,
        noOfReserve1Available: this.NoOfReserve1AvailablePopUp,
        noOfReserve2Available: 0,
      });

      this.hdnBookingSlotID.forEach((element) => {
        this.BookingSlotID = element;
        this.GenerateSlot(2);
      });
      this.closeEditPopup();
    },
    DeleteSlotMultiple() {
      var SelectedBookingSlotID = [];
      this.bookingSlot_List.forEach((element) => {
        if (element[16] == 1) SelectedBookingSlotID.push(element[0]);
      });

      if (SelectedBookingSlotID.length > 0) {
        if (confirm("Are you sure ?")) {
          this.BookingSlotID = -1;
          SelectedBookingSlotID.forEach((element) => {
            this.BookingSlotID = element;
            this.GenerateSlot(3);
            this.closeEditPopup();
          });
        }
      } else {
        alert("Select row for delete!");
      }
    },
  },
  computed: {},
  mounted() {
    //alert(new Date());
    this.GetSetupData();
  },
  watch: {
    BookingToDate(newValue, oldValue) {
      this.GetBookingSlots();
    },
  },
};
</script>
<style scoped>
.myhead::-webkit-scrollbar {
  background-color: transparent;
}
.myhead::scrollbar {
  background-color: transparent;
}
.mandatorySpan {
  text-align: left;
  position: relative;
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}
.mandatorySpan.Required:after {
  color: red;
  content: "*";
  position: absolute;
  height: 8px;
  top: -5px;
  font-size: 200%;
}
#divSummary {
  margin-left: 4px;
  margin-right: 5px;
  /* border: dotted 1px darkgray;
        border-radius: 5px;
        padding: 5px 0px 0px 5px; */
}
.ekkGrid > .Flex_Row:hover:not(.GridHeader),
.ekkGrid > .GridContent > .Flex_Row:hover:not(.GridHeader) {
  background-color: #ffa50069;
  color: black;
}
</style>
<style scoped>
.fade-enter-active {
  animation: fade-in 0.4s;
}
.fade-leave-active {
  animation: fade-in 0.4s reverse;
}
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  5% {
    opacity: 0.05;
  }
  10% {
    opacity: 0.1;
  }
  20% {
    opacity: 0.2;
  }
  25% {
    opacity: 0.25;
  }
  30% {
    opacity: 0.3;
  }
  35% {
    opacity: 0.35;
  }
  40% {
    opacity: 0.4;
  }
  45% {
    opacity: 0.45;
  }
  50% {
    opacity: 0.5;
  }
  55% {
    opacity: 0.55;
  }
  60% {
    opacity: 0.6;
  }
  65% {
    opacity: 0.65;
  }
  70% {
    opacity: 0.7;
  }
  75% {
    opacity: 0.75;
  }
  80% {
    opacity: 0.8;
  }
  85% {
    opacity: 0.85;
  }
  90% {
    opacity: 0.9;
  }
  95% {
    opacity: 0.95;
  }
  100% {
    opacity: 1;
  }
}
</style>
<style scoped>
.backgroundPopup {
  position: fixed;
  _position: absolute; /* hack for internet explorer 6*/
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background: #000000;
  border: 1px solid #cecece;
  z-index: 1;
  opacity: 0.5;
}
.PopUpCover {
  border: solid 1px;
  border-radius: 4px;
  top: 110px;
  position: absolute;
  min-height: 256px;
  right: 380px;
  /* background-color: ;rgba(255, 248, 248, 0.86); */
  background-color: ghostwhite;
  -webkit-box-shadow: 1px 1px 20px 1px white;
  box-shadow: 1px 1px 20px 1px white;
  border-radius: 8px 8px 8px 8px;
  z-index: 2;
  color: black !important;
  width: 600px;
}
.PopUpDetail {
  padding: 10px;
  /* min-height: 200px;
        max-height: 400px; */
  overflow: auto;
}
.PopUpHeader {
  padding: 5px !important;
  font-size: 13pt;
  min-height: 38px;
  border-bottom: solid 1px;
  border-radius: 8px;
}
.PopClose {
  line-height: 18px;
  right: 2px;
  top: 3px;
  position: absolute;
  color: white;
  font-weight: 700;
  display: block;
  padding: 5px;
  background-color: rgba(255, 0, 0, 0.94);
  border-radius: 6px;
  cursor: pointer;
  width: 28px;
  text-align: center;
}
.popbounce-enter-active {
  animation: popbounce-in 0.5s;
}
.popbounce-leave-active {
  animation: popbounce-in 0.4s reverse;
}
.tabClass {
  padding: 5px 8px;
  margin-right: 3px;
  font-size: medium;
  border: solid 1px black;
  border-radius: 6px 6px 0px 0px;
  text-align: center;
  font-family: consolas;
  cursor: pointer;
  border-right: solid 2px black;
  /* box-shadow: 3px 1px 4px; */
  background-color: white;
  color: Black;
}
.tabSelectClass {
  padding: 5px 8px;
  margin-right: 3px;

  background-color: rgb(1, 164, 246) !important;
  font-weight: bold;
  font-family: consolas;
  font-size: medium;
  border: solid 1px black;
  border-right: solid 2px black;
  border-radius: 6px 6px 0px 0px;
  text-align: center;
  border-right: solid 2px black;
  /* box-shadow: 3px 1px 4px black; */
  border-bottom: solid 2px black;
  cursor: pointer;
  color: white;
}
.page {
  padding: 10px;
  margin: 10px;
  border: solid 1px black;
}
@keyframes popbounce-in {
  0% {
    transform: scale(0);
  }
  25% {
    transform: scale(0.25);
  }
  50% {
    transform: scale(0.5);
  }
  75% {
    transform: scale(0.75);
  }
  100% {
    transform: scale(1);
  }
}
</style>
<style scoped>
@media screen and (max-width: 800px) {
  .EntryBlock {
    width: 80%;
  }
  #divApplication {
    display: block;
    height: auto;
  }
  #location {
    width: 70%;
  }
  .PopUpCover {
    right: 0px !important;
    left: 18px !important;
  }
  .EntryBlock {
    width: 100%;
  }
  fieldset > div {
    width: calc(100vw - 15px);
    overflow: auto;
  }
  .tblEntryForm {
    width: calc(100vw - 35px);
  } /* width 15px less*/
  .tblEntryForm .Flex_Row {
    display: flex;
    flex-wrap: wrap;
  } /* this is responsible for cell wraping*/
  .tblEntryForm .Flex_Row > .Flex_Cell {
    width: 50% !important;
  } /* width of any cell time of screen sizing*/
  .tblEntryForm .Flex_Row > .Flex_Cell_Inline {
    width: 50% !important;
    line-height: 36px;
  } /* width of any cell time of screen sizing*/
  /* Auto calculate the height of the grid div for scrolling when screen size change*/
  .Location {
    max-width: calc(100vw - 30px) !important;
    width: calc(100vw - 40px) !important;
  }
  /*Overflow for horizontal */
  .ekkGrid .GridContent {
    overflow: unset;
  }
  /*then only horizontal scrolling works */
  .Flex_Table.ekkGrid .Flex_Row {
    width: 100%;
  }
}
@media screen and (max-width: 480px) {
  .EntryBlock {
    width: calc(100vw - 35px);
  }
  fieldset > div {
    width: calc(100vw - 35px);
    overflow: auto;
  }
  #location {
    width: 70%;
  }
  .PopUpCover {
    right: 0px !important;
    left: 18px !important;
  }
  .tblEntryForm > .Flex_Row > .Flex_Cell {
    width: 100% !important;
  }
  .tblEntryForm > .Flex_Row > .Flex_Cell_Inline {
    width: 100% !important;
    line-height: 36px;
  }
  .tblEntryForm .divHR {
    display: block;
  }
  .Flex_Table.ekkGrid.Location {
    max-width: calc(100vw - 40px) !important;
    width: calc(100vw - 40px) !important;
  }
  legend {
    width: calc(100vw - 40px) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BookingSlots.vue